const details = [...document.querySelectorAll('details')];
document.addEventListener('click', function(e) {
  if (!details.some(f => f.contains(e.target))) {
    details.forEach(f => f.removeAttribute('open'));
  } else {
    details.forEach(f => e.target.href ? f.removeAttribute('open') : '');
  }
});
const watchNowSelect = document.querySelector('.watch-now-select');

const selectSelected = document.querySelector('.select-selected');
if (selectSelected) {
  selectSelected.onclick = () => {
    selectSelected.classList.toggle("select-arrow-active");
  };
  selectSelected.addEventListener('keyup', e => {
    if (e.key === 'Escape') _closeDetails();
  });

  selectSelected.nextElementSibling.querySelectorAll('a').forEach(a => {
    a.addEventListener('keyup', e => {
      if (e.key === 'Escape') _closeDetails();
    })
  });
};

function _closeDetails () {
  watchNowSelect.removeAttribute('open');
  selectSelected.classList.toggle("select-arrow-active");
  selectSelected.focus();
};
